// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 938) return "static/chunks/938-8511aaf38f441392.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "706bae84c7725303" + ".js";
};